import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

export const COMPARE_CHANGES_CAPTION = 'Compare changes for';

export const AttributeColumnWidth = {
    required: '7.5rem',
    attribute: '15rem',
    description: 'calc(85% - 42.5rem)',
    dataType: '11rem',
    possibleValues: '15%',
    deprecated: '9rem',
    lastUsageDate: '11rem',
};

export const SuccessNotification = {
    [ChangeRequestStatus.WAITING_REVIEW]: 'WAITING REVIEW',
    [ChangeRequestStatus.NEW]: 'NEW',
    [ChangeRequestStatus.APPROVED]: 'APPROVED',
    [ChangeRequestStatus.REOPENED]: 'REOPENED',
    [ChangeRequestStatus.REJECTED]: 'REJECTED',
    [ChangeRequestStatus.IN_REVIEW]: 'IN REVIEW',
    [ChangeRequestStatus.WAITING_APPROVE]: 'WAITING APPROVE',
};

export enum PushNotificationIds {
    startReviewSuccess = 'startReviewSuccess',
    startReviewFailure = 'startReviewFailure',
    stopReviewSuccess = 'stopReviewSuccess',
    stopReviewFailure = 'stopReviewFailure',
    sendToApproveSuccess = 'sendToApproveSuccess',
    sendToApproveFailure = 'sendToApproveFailure',
    approveSuccess = 'approveSuccess',
    approveFailure = 'approveFailure',
    reopenSuccess = 'reopenSuccess',
    reopenFailure = 'reopenFailure',
    rejectSuccess = 'rejectSuccess',
    rejectFailure = 'rejectFailure',
}
